import {
    validatorAte64Anos,
    retornaLabelDoValorParentesco,
    validatorParentescoEmDuplicidade,
    validatorMaior79Anos,
    validatorMaiorIgual65Anos,
    validatorMaiorIgual79Anos,
    faixaEtaria,
    encontrarCategoriaPorCodigo
} from './funcoesAuxiliaresZTI';

export class CorrenteEdicaoZTI {
    constructor(
        dependentes,
        parentesco,
        categorias,
        idadeAssociado,
        valoresForm,
        isValid,
        valoresAnterioresForm
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.idadeAssociado = idadeAssociado;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }

    infringeParentescoComAdicionalAte64() {
        if (validatorAte64Anos(this.valoresForm)) {
            this.arrayMsgsErro.push(
                `Para dependentes de até 64 anos, o adicional permitido é o ${encontrarCategoriaPorCodigo(
                    'ZTA64'
                )}.`
            );
        }

        return this;
    }

    infringeParentescoComAdicionalMaiorIgual65() {
        if (validatorMaiorIgual65Anos(this.valoresForm)) {
            this.arrayMsgsErro.push(
                `Para dependentes com idades entre 65 e 79 anos, o adicional permitido é o ${encontrarCategoriaPorCodigo(
                    'ZTA65'
                )}.`
            );
        }

        return this;
    }

    parentescoComAdicionalMaior79() {
        if (validatorMaior79Anos(this.valoresForm)) {
            this.arrayMsgsErro.push(
                `Para dependentes acima de 79 anos, o adicional permitido é o ${encontrarCategoriaPorCodigo(
                    'ZTA79'
                )}.`
            );
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(
                `${retornaLabelDoValorParentesco(this.parentesco)}`
            );
        }

        return this;
    }

    possui2VidasMaiorIgual79Anos() {
        if (
            validatorMaiorIgual79Anos(
                this.valoresForm,
                this.dependentes,
                this.idadeAssociado
            )
        ) {
            this.arrayMsgsErro.push(
                'Neste plano só é permitido duas pessoas acima de 80 anos, incluindo o titular.'
            );
        }

        return this;
    }

    verificarMudancaIdade() {
        const idadeValida = this.isValid.Idade > faixaEtaria.maior && this.valoresForm.Idade > faixaEtaria.maior;
        const idadeAssociadoMaiorIgual80 = validatorMaiorIgual79Anos(
            this.valoresForm,
            this.dependentes,
            this.idadeAssociado
        );

        if (!idadeValida && idadeAssociadoMaiorIgual80) {
            this.arrayMsgsErro.push(
                'Neste plano só é permitido duas pessoas acima de 80 anos, incluindo o titular.'
            );
        }

        return this;
    }
}
